import { FieldArray, useFormikContext } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';
import durationData from '../../../../data/durationData';
import useFetch from '../../../../hooks/useFetch';
import request from '../../../../request/request';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import ReactSelect from '../../../ReactSelect/ReactSelect';
import ErrorMsg from '../../../Text/ErrorMsg';
import FormLabel from '../../../Text/FormLabel';
// import IncludedForm from './IncluedForm';
// import ExcludedForm from './ExcludedForm';
// import HighlightsBulletpointsForm from './Highlights_bulletpointsForm';
// import ItineraryForm from './ItineraryForm';
// import months from '../../../../data/staticsData/mouthData';
import ReactTextEditor from '../../../Editors/ReactTextEditor';

const VisaForm = () => {
    // const { result: categories } = useFetch(() => request.getAll('package-category?status=1'));
    const { result: visaTypes } = useFetch(() => request.getAll('visa_type'));
    const { result: destination } = useFetch(() => request.getAll('destination'));
    // const { result: travelCategory } = useFetch(() => request.getAll('travelCategory'));
    // const { result: facility } = useFetch(() => request.getAll('facility-management'));
    const { values, setFieldValue } = useFormikContext();
    // const { incluevalues, setFieldIncluevalues } = useFormikContext();
    // console.log(location);
    console.log('values visa', values);
    return (
        <div>
            {/* <Form.Group as={Row}>
                <Col sm={12} md={4}>
                    <FormLabel title='Travel Category' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactSelect
                        data={travelCategory}
                        value={values.travelCategoryId}
                        onChange={(val) => setFieldValue('travelCategoryId', val)}
                    />
                    <ErrorMsg name='travelCategoryId' />
                </Col>
            </Form.Group> */}
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Name' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='name' placeholder='Name' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Image' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='image' type='file' />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Visa Type' required />
                </Col>
                <Col sm={12} md={8}>
                    {/* <ReactMultiSelect */}
                    <ReactSelect
                        data={visaTypes}
                        value={values.visa_type}
                        // valueName='name'
                        labelName='name'
                        onChange={(val) => setFieldValue('visa_type_id', val)}
                    />
                    <ErrorMsg name='visa_type_id' />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Country' required />
                </Col>
                <Col sm={12} md={8}>
                    {/* <ReactMultiSelect */}
                    <ReactSelect
                        data={destination}
                        value={values.destination_id}
                        // valueName='country_name'
                        labelName='country_name'
                        onChange={(val) => setFieldValue('destination_id', val)}
                    />
                    <ErrorMsg name='destination_id' />
                </Col>
            </Form.Group>
            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Facilities' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactSelect
                        data={facility}
                        value={values.facility}
                        onChange={(val) => setFieldValue('facility', val)}
                    />
                    <ErrorMsg name='Facility' />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Features' required />
                </Col>
                <Col sm={12} md={8}>
                    <FieldArray
                        name='features'
                        render={(arrayHelpers) => (
                            <FeaturesForm remove={arrayHelpers.remove} add={arrayHelpers.push} />
                        )}
                    />
                </Col>
            </Form.Group> */}

            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Price' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='price' placeholder='Price' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Discount (in %)' />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='package_discount' placeholder='Discount' type='number' />
                </Col>
            </Form.Group>
            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Minimum Age' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='min_age' placeholder='Minimum Age' />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Duration' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactSelect
                        data={durationData}
                        placeholder='Select Duration'
                        labelName='title'
                        valueName='value'
                        value={values.duration}
                        onChange={(val) => setFieldValue('duration', val)}
                    />
                    <ErrorMsg name='duration' />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Tour Month' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactSelect
                        data={months}
                        placeholder='Select Month'
                        labelName='name'
                        valueName='name'
                        value={values.tour_month}
                        onChange={(val) => setFieldValue('tour_month', val)}
                    />
                    <ErrorMsg name='tour_month' />
                </Col>
            </Form.Group> */}
            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Included' required />
                </Col>
                <Col sm={12} md={8}>
                    <FieldArray
                        name='included'
                        render={(arrayHelpers) => (
                            <IncludedForm remove={arrayHelpers.remove} add={arrayHelpers.push} />
                        )}
                    />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Excluded' required />
                </Col>
                <Col sm={12} md={8}>
                    <FieldArray
                        name='excluded'
                        render={(arrayHelpers) => (
                            <ExcludedForm remove={arrayHelpers.remove} add={arrayHelpers.push} />
                        )}
                    />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Description' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='description' placeholder='Description' />
                </Col>
            </Form.Group> */}

            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Description' required />
                </Col>
                <Col sm={12} md={8}>
                    {/* <ReactInput name='description' placeholder='Description' /> */}
                    <ReactTextEditor
                        defaultData={values.description}
                        setEditorData={(val) => setFieldValue('description', val)}
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Max Stays' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='max_stays' placeholder='Max Stays' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Validity' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='validity' placeholder='Validity' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Visa Mode' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='visa_mode' placeholder='Visa Mode' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Required Documents' required />
                </Col>
                <Col sm={12} md={8}>
                    {/* <ReactInput name='required_documents' placeholder='required_documents' /> */}
                    <ReactTextEditor
                        defaultData={values.required_documents}
                        setEditorData={(val) => setFieldValue('required_documents', val)}
                    />
                </Col>
            </Form.Group>

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Highlighted Description' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput
                        name='highlights_description'
                        placeholder='Highlighted Description'
                    />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Highlighted Points' required />
                </Col>
                <Col sm={12} md={8}>
                    <FieldArray
                        name='highlights_bulletpoints'
                        render={(arrayHelpers) => (
                            <HighlightsBulletpointsForm
                                remove={arrayHelpers.remove}
                                add={arrayHelpers.push}
                            />
                        )}
                    />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Itinerary' required />
                </Col>
                <Col sm={12} md={8}>
                    <FieldArray
                        name='itinerary'
                        render={(arrayHelpers) => (
                            <ItineraryForm remove={arrayHelpers.remove} add={arrayHelpers.push} />
                        )}
                    />
                </Col>
            </Form.Group> */}

            {/* <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Color' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='color' placeholder='Color' type='color' />
                </Col>
            </Form.Group> */}
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Success Count' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='success_count' placeholder='Success Count' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Featured' />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='featured' label='Featured' type='checkbox' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Popular' />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='popular' label='Popular' type='checkbox' />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className='mt-3'>
                <Col sm={12} md={4}>
                    <FormLabel title='Status' required />
                </Col>
                <Col sm={12} md={8}>
                    <ReactInput name='status' label='Active' type='checkbox' />
                </Col>
            </Form.Group>
        </div>
    );
};

export default VisaForm;
